import React, { Fragment } from 'react'
import "./Footer.css"

const Footer = () => {
  return <Fragment>
    <div className='footer'>
      Created By : SonamDangi &copy; all copy-rights reserved 
    </div>
  </Fragment>
}

export default Footer
